<template>
  <div class="position-relative">
    <div class="mt-2 ml-2 mr-2 position-absolute" v-if="deletable" style="z-index: 1;">
      <ci-awesome-icon icon="times" button @click="onDeleteClick" />
    </div>
    <div>
      <img :src="`${image.file_url}`" :class="{'img-fluid': true, 'rounded-circle': this.rounded }" @dragstart="$event.preventDefault()" style="max-width: 100%;">
    </div>
  </div>
</template>

<script>
import AwesomeIcon from '@/components/AwesomeIcon.vue';

export default {
  name: 'ElementImage',

  components: {
    'ci-awesome-icon': AwesomeIcon,
  },

  props: {
    deletable: {
      type: Boolean,
      default: false,
      required: false,
    },

    image: {
      type: Object,
      required: true,
    },

    rounded: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  computed: {
    getImageUrl() {
      return `${this.image.fileUrl}/${this.image.name}`;
    },
  },

  methods: {
    onDeleteClick() {
      this.$emit('image:delete', this.image);
    },
  },
};
</script>
